import logger from '@/sdk/logger'
import { userRequest } from '@/sdk/oauth'
import { Contract, ServiceRequest } from '@/store/user/types'

export function createServiceRequestDraft(customerId: string) {
  return userRequest
    .post('/booking/service-request-draft', { customer_id: customerId })
    .then(response => response.data)
    .catch(error => {
      logger.error('failed creating a service request draft', {
        error,
        tags: ['registration', 'http', 'user', 'serviceRequestDraft'],
      })

      throw error
    })
}

export function updateDraft(payload, draftUuid) {
  return userRequest
    .post(`/booking/service-request-draft/${draftUuid}`, payload)
    .then(response => response.data)
}

export function finalizeDraft(draftUuid) {
  return userRequest
    .post(`/booking/service-request-draft/finalize/${draftUuid}`)
    .then(response => response)
    .catch(error => {
      logger.error('failed while attempting to finalize the SR draft', {
        error,
        tags: ['bookingFunnel', 'http', 'SR draft'],
      })

      throw error
    })
}

export function getServiceRequest(
  serviceRequestId: string,
): Promise<ServiceRequest> {
  return new Promise((resolve, reject) => {
    userRequest
      .get(`/customer/service-request/${serviceRequestId}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error))
  })
}

export function getContract(contractId: string): Promise<Contract> {
  return new Promise((resolve, reject) => {
    userRequest
      .get(`/customer/contract/${contractId}`)
      .then(response => resolve(response.data))
      .catch(error => reject(error))
  })
}

export async function getServiceRequestDrafts() {
  return userRequest
    .get('/customer/service-request-draft')
    .then(response => response.data)
    .catch(() => [])
}

export async function addPostcodeToServiceRequestDraft(
  draftId: string,
  postcode: string,
) {
  const payload = {
    update: {
      type: 'post_code',
      data: {
        post_code: postcode,
      },
    },
  }

  return userRequest
    .post(`/booking/service-request-draft/${draftId}`, payload)
    .then(response => response)
    .catch(error => {
      logger.error('failed setting the postcode to the SR draft', {
        error,
        tags: ['registration', 'http', 'user', 'serviceRequestDraft'],
      })

      throw error
    })
}
